import DailyProducts from './DailyProducts'

export default DailyProducts



// WEBPACK FOOTER //
// ./src/components/DailyProducts/index.js